import React from 'react';
import ManufacturingListContainer from '../../containers/manufacturingmng/ManufacturingListContainer';

/**
 * 제조관리 목록 페이지 (Plan A 방안)
 * - 프로젝트 목록 + 제조 진행 요약을 한 화면에 표시
 * - /manufacturingmng 첫 화면
 */
const ManufacturingListPage = () => {
  const pageUrl = '/manufacturingmng';
  
  return <ManufacturingListContainer pageUrl={pageUrl} />;
};

export default ManufacturingListPage;
